import { createStandardAction } from 'typesafe-actions';

export const setSelectedComponents = createStandardAction(
  'CLASSDIGITALNOTEBOOK/SET_SELECTED_COMPONENTS'
)<{ components: Array<any> }>();
